import { PreInterviewApproveCommand, PreInterviewExpiredFault } from '@dreryk/egabinet-pre-interview-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';

type PreInterviewApproveActionRenderProps = {
   approvePreInterview: PromiseVoidFunction;
};

type PreInterviewApproveActionProps = {
   appointmentId: number;
   children: (renderProps: PreInterviewApproveActionRenderProps) => JSX.Element;
   onSuccess?: VoidFunction | PromiseVoidFunction;
   onPreInterviewExpiredFault: VoidFunction;
};

export const PreInterviewApproveAction = (props: PreInterviewApproveActionProps): JSX.Element => {
   const { executeAsync: approvePreInterview } = useCqrsCommand<void, void, PreInterviewExpiredFault>(
      () => {
         const command = new PreInterviewApproveCommand();
         command.appointmentId = props.appointmentId;
         return command;
      },
      {
         onSuccess: async () => {
            await props.onSuccess?.();
            dispatchSnackbarPositiveEvent(
               appointmentsTranslationKeys.preInterview.modal.create.form.actions.confirm.successMessage
            );
         },
         onFault: {
            'egabinet-pre-interview-frontend-api:PreInterviewExpiredFault': () => {
               props.onPreInterviewExpiredFault();
               dispatchSnackbarNegativeEvent(
                  appointmentsTranslationKeys.preInterview.modal.create.form.errors.preInterviewExpiredFault
               );
            },
         },
      }
   );

   return props.children({
      approvePreInterview: approvePreInterview,
   });
};
